import React, { useState, useEffect, useRef } from "react";
import { Form, Button, Spin, Input } from "antd";
import * as _ from "lodash";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";

import { TEXT_DEF, CREATE_SUCCESS, CREATE_FAIL, GET_DATA_FAIL } from "../../constant/text";
import API, { RANK } from "../../network/api";

const RankCreate = () => {
    let isRequest = useRef(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            getRankById();
        }
    }, []);

    const getRankById = async () => {
        try {
            setLoading(true);
            const result = await API.get(`${RANK}/${id}`);
            setLoading(false);
            const response = _.get(result, 'data.data', false);
            form.setFieldsValue({
                rankName: response.rankName || 0,
                maxBetAmount: response.maxBetAmount || 0,
            });
        } catch (err) {
            setLoading(false);
            toast(GET_DATA_FAIL);
        }
    }

    const createOrEditRank = async () => {
        if (isRequest.current) {
            return;
        };

        isRequest.current = true;
        const body = {
            rankName: form.getFieldValue("rankName"),
            maxBetAmount: form.getFieldValue("maxBetAmount"),
        };

        try {
            setLoading(true);
            let result;
            if (!id) {
                result = await API.post(RANK, body);
            } else {
                result = await API.patch(`${RANK}/${id}`, body);
            }
            setLoading(false);
            const status = _.get(result, 'data.success', false);
            isRequest.current = false;
            if (status === true) {
                toast(CREATE_SUCCESS);
                navigate("/ranks");
            } else {
                toast(CREATE_FAIL);
            }
        } catch (err) {
            setLoading(false);
            isRequest.current = false;
            toast(CREATE_FAIL);
        }
    }

    return (
        <Spin spinning={loading} delay={500} size="large">
            <Form
                className="form-create"
                form={form}
                layout="inline"
                autoComplete="off"
                onFinish={createOrEditRank}
            >
                <div className="col-8">
                    <div
                        className="col-12"
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <div className="col-3">
                            Name <span style={{ color: "red" }}>*</span>
                        </div>
                        <div className="col-9">
                            <Form.Item
                                name="rankName"
                                rules={[
                                    {
                                        required: true,
                                        message: TEXT_DEF.text0004,
                                    },
                                ]}
                                style={{ marginRight: 0 }}
                            >
                                <Input maxLength={255} />
                            </Form.Item>
                        </div>
                    </div>
                    <div style={{ marginBottom: 30 }} />

                    <div
                        className="col-12"
                        style={{ display: "flex", alignItems: "center" }}
                    >
                        <div className="col-3">
                        Số tiền đặt cược lớn nhất <span style={{ color: "red" }}>*</span>
                        </div>
                        <div className="col-9">
                            <Form.Item
                                name="maxBetAmount"
                                rules={[
                                    {
                                        required: true,
                                        message: TEXT_DEF.text0004,
                                    },
                                    {
                                        type: 'number',
                                        min: 0,
                                        message: "Nhập kiểu số",
                                        transform(value) {
                                            if (!value) return;

                                            return Number(value)
                                        },
                                    },
                                ]}
                                style={{ marginRight: 0 }}
                            >
                                <Input maxLength={255} />
                            </Form.Item>
                        </div>
                    </div>
                    <div style={{ marginBottom: 30 }} />

                    <Form.Item shouldUpdate style={{ width: "100%" }}>
                        {() => (
                            <div className="lg-btn">
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={
                                        !form.isFieldsTouched(true) ||
                                        !!form
                                            .getFieldsError()
                                            .filter(({ errors }) => errors.length).length
                                    }
                                >
                                    {!id ? TEXT_DEF.text0018 : TEXT_DEF.text0016}
                                </Button>
                            </div>
                        )}
                    </Form.Item>
                </div>
            </Form>
        </Spin>
    );
}

export default RankCreate;